export default "__VITE_ASSET__BmuoKXEy__"